import { createFileRoute } from "@tanstack/react-router";
import Events from "@/components/events/Events";

export const Route = createFileRoute("/events/")({
	component: () => <Events />,
});
